import { render, staticRenderFns } from "./UserTabLogs.vue?vue&type=template&id=057dbd64&scoped=true"
import script from "./UserTabLogs.vue?vue&type=script&lang=js"
export * from "./UserTabLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057dbd64",
  null
  
)

export default component.exports